import { useState, useEffect } from 'react';
import { settingsService } from '../services/settingsService';

/**
 * Hook that checks the effective setting 'scanning.enableGlobalBarcodeCapture'.
 * Returns whether the global barcode scanner (useSimpleBarcodeScanner + MobileBarcodeCaptureInput)
 * should be enabled.
 *
 * Bruker getEffectiveSetting slik at Profile-overrides respekterer hierarkiet
 * (Profile → System → Default). Default: false (scanner deaktivert med mindre eksplisitt slått på).
 */
export function useBarcodeScannerEnabled(): boolean {
  const [enabled, setEnabled] = useState<boolean>(false);

  useEffect(() => {
    let cancelled = false;

    const loadSetting = async () => {
      try {
        const setting = await settingsService.getEffectiveSetting('scanning.enableGlobalBarcodeCapture');
        if (!cancelled) {
          if (setting && setting.currentValue !== null && setting.currentValue !== undefined) {
            const val = setting.currentValue.toString().toLowerCase();
            setEnabled(val === 'true' || val === '1' || val === 'ja');
          } else {
            setEnabled(false);
          }
        }
      } catch (err) {
        console.warn('Could not load scanning.enableGlobalBarcodeCapture setting, defaulting to false:', err);
        if (!cancelled) {
          setEnabled(false);
        }
      }
    };

    loadSetting();

    return () => { cancelled = true; };
  }, []);

  return enabled;
}
